<template>
  <div class="collect-data" v-loading="loading">
    <div class="filter-wrap">
      <div class="filter-item">
        <span class="label">设备ID</span>
        <el-input v-model="deviceId" placeholder="请输入设备ID"></el-input>
      </div>
      <div class="filter-item">
        <span class="label">指标名称</span>
        <el-input v-model="metricName" placeholder="请输入指标名称"></el-input>
      </div>
      <div class="filter-item">
        <span class="label">采集时间</span>
        <el-date-picker
          v-model="collectDate"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
        ></el-date-picker>
      </div>
      <BaseButton @click="refresh">查询</BaseButton>
    </div>
    <section class="main-wrap">
      <base-table
        ref="BaseTable"
        tableHeight="100%"
        :data="logs"
        :pageInfo="pageInfo"
        @page-change="refresh"
      >
        <el-table-column
          v-for="item in logColumns"
          :key="item.value"
          :label="item.label"
          :width="item.width"
          :prop="item.value"
          :column-key="item.value"
          show-overflow-tooltip
        ></el-table-column>
      </base-table>
    </section>
  </div>
</template>

<script>
import { logColumns } from "@/views/IOT/DeviceLog/static"
import BaseTable from "@/components/UIComponents/BaseTable"
import BaseButton from "@/components/UIComponents/Button"
import { getDataList } from "@/api/iot/device"
import mixin from "@/views/IOT/DeviceLog/mixin"

export default {
  name: "CollectData",
  components: { BaseButton, BaseTable },
  data() {
    return {
      logColumns,
      loading: false,
      deviceId: null,
      metricName: null,
      collectDate: [],
      logs: [],
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      }
    }
  },
  mixins: [mixin],
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      let param = {
        sn: this.deviceId,
        metricName: this.metricName,
        endTime: this.collectDate && this.collectDate.length ? this.collectDate[1] : null,
        startTime: this.collectDate && this.collectDate.length ? this.collectDate[0] : null
      }
      getDataList(param).then(res => {
        if (res !== undefined) {
          this.logs = res
        }
        this.resetPageInfo(this.logs)
        this.loading = false
      })
    },
    changeDeviceId(id) {
      this.deviceId = id
      this.refresh()
    }
  }
}
</script>

<style lang="scss" scoped>
.collect-data {
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .filter-wrap {
    display: flex;
    margin: 10px 20px;
    font-size: 14px;
    .filter-item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .label {
        width: 60px;
      }
      .el-input {
        flex: 1;
      }
    }
  }
  .main-wrap {
    flex: 1 1;
    overflow: hidden;
    padding: 0 20px;
    .base-table {
      height: 100%;
    }
  }
}
</style>
